const Users = require("./containers/Users");
const AuthenticateAdmin = require("../utils").authenticateAdmin;

// Sync route definition
module.exports = {
    path: "/admin/users",
    component: AuthenticateAdmin(Users),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/admin-users/index.js